module.exports = __webpack_public_path__ + "static/media/cross-shield.6feb257e.svg";